import { LINKS, SCENARIO_TEMPLATES_REVALIDATE_TIME } from 'routes/constants'
import { fetchAllScenarios } from 'routes/Scenarios/helpers'
import { ScenarioTemplateCompact } from 'routes/Scenarios/helpers/types'
import PushDataToExternalApp from 'routes/Solutions/PushDataToExternalApp'

export default function PushDataToExternalAppPage({
  scenarioTemplates,
}: {
  scenarioTemplates: ScenarioTemplateCompact[]
}) {
  return <PushDataToExternalApp scenariosByTag={scenarioTemplates} />
}

export async function getStaticProps() {
  const scenarioTemplates = (await fetchAllScenarios()).filter(({ tags }) =>
    tags.includes(LINKS.SOLUTIONS.PUSH_DATA_TO_EXTERNAL_APPS.TAG),
  )

  return {
    props: { scenarioTemplates },
    revalidate: SCENARIO_TEMPLATES_REVALIDATE_TIME,
  }
}
